'use client'

// MUI Imports
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

// Component Imports

import { signIn } from 'next-auth/react'

// Config Imports

import themeConfig from '@configs/themeConfig'

import { ENV_VAR } from '@/services'
import Image from 'next/image'

const LoginV1 = ({ imageData }: any) => {
  // const LoginV1 = () => {
  // console.log(imageData)
  const url = imageData ? imageData?.data?.attributes?.url : '/images/illustrations/auth/Edificio-K.webp'

  return (
    <div
      className='flex flex-col justify-center items-center min-bs-[100dvh] relative p-6 bg-cover bg-center'
      style={{
        // backgroundImage: "url('/images/illustrations/auth/Edificio-K.webp')",

        backgroundImage: `url('${ENV_VAR.STRAPI_URL}${url}')`,
        backgroundColor: '#bf1b1b'
      }}
    >
      <Card className='flex flex-col sm:is-[450px]'>
        <CardContent className='p-6 sm:!p-12'>
          <div className='w-full flex items-center justify-center'>
            <Image src='/images/illustrations/auth/logo-ua-1.png' width={100} height={100} alt='' />
          </div>
          <div className='flex flex-col gap-5'>
            <div>
              <Typography variant='h4'>{`Te damos la bienvenida a ${themeConfig.templateName}👋🏻`}</Typography>
              <Typography className='mbs-1' sx={{color:'black'}}>Ingresa a tu cuenta</Typography>
            </div>

            <Button fullWidth variant='contained' onClick={() => signIn('azure-ad')}>
              {'Iniciar sesión'.toUpperCase()}
            </Button>
          </div>
        </CardContent>
      </Card>
      {/* <Illustrations /> */}
    </div>
  )
}

export default LoginV1
